module.exports = "/assets/site/images/Prize&More_logo.jpg?50487fe1621486b948b422080c488114";